/**
* @license Apache-2.0
*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //

var setReadOnly = require( '@stdlib/utils-define-read-only-property' );


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name base
* @memberof ns
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/blas/ext/base}
*/
setReadOnly( ns, 'base', require( '@stdlib/blas-ext-base' ) );

/**
* @name cusum
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/blas/ext/cusum}
*/
setReadOnly( ns, 'cusum', require( '@stdlib/blas-ext-cusum' ) );

/**
* @name findIndex
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/blas/ext/find-index}
*/
setReadOnly( ns, 'findIndex', require( '@stdlib/blas-ext-find-index' ) );

/**
* @name findLastIndex
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/blas/ext/find-last-index}
*/
setReadOnly( ns, 'findLastIndex', require( '@stdlib/blas-ext-find-last-index' ) );

/**
* @name indexOf
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/blas/ext/index-of}
*/
setReadOnly( ns, 'indexOf', require( '@stdlib/blas-ext-index-of' ) );

/**
* @name lastIndexOf
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/blas/ext/last-index-of}
*/
setReadOnly( ns, 'lastIndexOf', require( '@stdlib/blas-ext-last-index-of' ) );

/**
* @name linspace
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/blas/ext/linspace}
*/
setReadOnly( ns, 'linspace', require( '@stdlib/blas-ext-linspace' ) );

/**
* @name sorthp
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/blas/ext/sorthp}
*/
setReadOnly( ns, 'sorthp', require( '@stdlib/blas-ext-sorthp' ) );

/**
* @name sum
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/blas/ext/sum}
*/
setReadOnly( ns, 'sum', require( '@stdlib/blas-ext-sum' ) );

/**
* @name toSortedhp
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/blas/ext/to-sortedhp}
*/
setReadOnly( ns, 'toSortedhp', require( '@stdlib/blas-ext-to-sortedhp' ) );


// EXPORTS //

module.exports = ns;
